'use client';

import { useState, useEffect } from 'react';
import { ComponentFields } from 'types/content';
import SectionNavigation from './SectionNavigation';
import PartsOfMedicare from './PartsOfMedicare';
import PartABExplainer from './PartABExplainer';
import WhatsSupp from './WhatsSupp';
import MAExplainer from './MAExplainer';

const LongFormEducation = ({ onContinue }: ComponentFields) => {
  const [currentSection, setCurrentSection] = useState<number>(0);
  const nextSection = () => {
    let section = currentSection + 1;

    if (section > 3) {
      section = 3;
    }

    setCurrentSection(section);
  };

  const previousSection = () => {
    let section = currentSection - 1;
    if (section < 0) {
      section = 0;
    }

    setCurrentSection(section);
  };

  const goToSection = (section: number) => setCurrentSection(section);

  const sections = [
    { id: 0, title: 'Part A: Hospital Insurance and Part B' },
    { id: 1, title: 'How Does Medicare Cover My Costs?' },
    { id: 2, title: 'Medicare Supplement Plan G and Part D Coverage' },
    {
      id: 3,
      title: 'Medicare Advantage: Bundle Parts A, B, and D into 1 plan',
    },
  ];

  const renderSection = (sectionId: number) => {
    switch (sectionId) {
      case 0:
        return <PartsOfMedicare />;
      case 1:
        return <PartABExplainer />;
      case 2:
        return <WhatsSupp />;
      case 3:
        return <MAExplainer />;
      default:
        return <PartsOfMedicare />;
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentSection]);

  return (
    <div className="long-form-section">
      <div className="header">
        <h2>Medicare Education</h2>
        <div className="lfe-page-selection">
          <p>What are the Parts of Medicare?</p>
          <form>
            <select
              value={currentSection}
              onChange={(e) => goToSection(Number(e.target.value))}
            >
              {sections.map((section) => (
                <option key={section.id} value={section.id}>
                  {section.title}
                </option>
              ))}
            </select>
          </form>
        </div>
      </div>

      <div>{renderSection(currentSection)}</div>

      <SectionNavigation
        current={currentSection}
        onContinue={onContinue}
        goBack={previousSection}
        goForward={nextSection}
      />
    </div>
  );
};

export default LongFormEducation;
